<template>
<div>
  <div class="footer">
    <div class="logo">
      <router-link to="/"><img class="logo-img" src="../assets/logo_footer.png" alt="フッターロゴ"></router-link>
    </div>
    <div>
      <ul class="footer-navi-list">
        <router-link to="/company"><li class="footer-navi-item">会社概要</li></router-link>
        <router-link to="/about"><li class="footer-navi-item">セルフエステエンリケとは？</li></router-link>
        <router-link to="/privacypolicy"><li class="footer-navi-item">プライバシーポリシー</li></router-link>
        <router-link to="/contact"><li class="footer-navi-item">お問い合わせ</li></router-link>
        <router-link to="/sctl"><li class="footer-navi-item">特定商取引法に基づく表記</li></router-link>
      </ul> 
    </div>
  </div>
  <div class="copyright">
    SELF ESTHE ENRIKE
  </div>
</div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
  .logo{
    margin-left: 7vw;
  }

  .footer-navi-list {
    list-style: none;
    overflow: hidden;
    margin-right: 12vw;
  }

  .footer-navi-item:hover{
    opacity: 0.5;
    transition:0.3s ease-in-out;
  }

  .copyright{
    color: white;
    background-color: #606060;

    text-align: center;

    padding: 10px;
  }

   /* PC表示 */
  @media screen and (min-width:821px){
    .footer{
      background-color: var(--main-color);
      display: flex;
      justify-content: space-between;
      padding: 50px 0;
    }

    .footer-navi-item{
      font-size: 20px;
      
      color: white;
      margin: 1.5em auto;
    }

    .logo-img{
      width: 20vw;
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .footer{
      background-color: var(--main-color);
      display: flex;
      justify-content: space-between;
      /*padding: 15px 0;*/
      padding: 15px 0;
      padding-bottom:50px;
    }

    .footer-navi-item{
      font-size: 3vw;
      font-weight: 50;
      color: white;
      margin: 1.5em auto;
    }

    .logo-img{
      width: 40vw;
    }
  }
</style>